import styled from 'styled-components';

const AccordionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const AccordionBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const AccordionInputStyle = {
  AccordionHeader,
  AccordionBody,
};

export default AccordionInputStyle;
